import { Identifiable, List } from "@planzone/dto";
import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { reduceTask } from "../task";
import { reduceMilestone } from "../milestone";

function editTasks(
  list: Identifiable<List>,
  data: Boundaries["constrainElements"]["success"],
) {
  return list.tasks.map((task) =>
    reduceTask(task, { type: events.constrainElementsSucceeded, data }),
  );
}

function editMilestones(
  list: Identifiable<List>,
  data: Boundaries["constrainElements"]["success"],
) {
  return list.milestones.map((milestone) =>
    reduceMilestone(milestone, {
      type: events.constrainElementsSucceeded,
      data,
    }),
  );
}

function editSubLists(
  list: Identifiable<List>,
  data: Boundaries["constrainElements"]["success"],
) {
  return list.subLists.map((subList) => editList(subList, data));
}

function editList(
  list: Identifiable<List>,
  data: Boundaries["constrainElements"]["success"],
): Identifiable<List> {
  const impactedList = data.impactedElements.find(
    ({ uuid }) => uuid === list.uuid,
  );

  return {
    ...list,
    ...(impactedList || {}),
    tasks: editTasks(list, data),
    milestones: editMilestones(list, data),
    subLists: editSubLists(list, data),
  };
}

function handleConstrainElements(
  list: Identifiable<List>,
  data: Boundaries["constrainElements"]["success"],
): Identifiable<List> {
  return editList(list, data);
}

export { handleConstrainElements };
